import Vue from 'vue'
import Vuex from 'vuex'

import tabs from './modules/tabs'
import user from './modules/user'
import websocket from './modules/websocket'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters,
  mutations: {
  },
  actions: {
  },
  modules: {
    tabs,
    user,
    websocket
  }
})
